import React from "react"
import { MobergDropdown } from "../../../../Moberg"
import { QEEG_CHANNEL_GROUPS, QEEGChannelGroupId } from "../../../../Pages/Data/Visualize/DataReview/Types/AnalysisDetails"

const CHANNEL_GROUP_OPTIONS: Array<{ label: string; value: QEEGChannelGroupId }> = QEEG_CHANNEL_GROUPS.map(channelGroup => ({
	label: channelGroup.name,
	value: channelGroup.id,
}))

interface QEEGChannelGroupDropdownProps {
	selectedValue: QEEGChannelGroupId
	onChange: (channelGroupId: QEEGChannelGroupId) => void
	dataTestId?: string
	width?: number
}

export const QEEGChannelGroupDropdown: React.FC<QEEGChannelGroupDropdownProps> = ({ selectedValue, onChange, dataTestId, width = 175 }) => (
	<MobergDropdown
		dataTestId={dataTestId}
		options={CHANNEL_GROUP_OPTIONS}
		selectedValue={selectedValue}
		onChange={onChange}
		width={width}
	/>
)
